

















import { Component, Vue, Prop } from "vue-property-decorator";
import { List } from 'vant';
import { ErrorCode, ErrorInfo } from "@/network/http";
import { formatMessage } from "@/locale";
import { DiscussTopicInfo, DiscussTopicList } from  "@/data/local/discuss";
import DiscussTopicItem from "@/components/DiscussTopicItem.vue";

Vue.use(List);

@Component({
    components: {
        "v-discuss-topic-item": DiscussTopicItem
    }
})
export default class DiscussTopicListPage extends Vue {
    @Prop(Number)
    cityId: number;
    @Prop(Number)
    cat: number;

    pageNo: number = 1;
    pageSize: number = process.env.VUE_APP_DEFAULT_PAGE_SIZE;
    immCheck: boolean = false;
    listLoading: boolean = false;
    listFinished: boolean = false;
    listLoadError: boolean = false;
    listLoadingText: string = formatMessage({id: "message.common.loading"});
    finishText: string = formatMessage({id: "message.common.listNoMore"});
    listErrorText: string = formatMessage({id: "message.common.listError"});

    listData: DiscussTopicInfo[] = [];

    
    keyword: string = "";

    mounted() {
        this.listData = [];
        this.pageNo = 1;
        this.fetchList();
    }

    fetchList(): void {
        this.listLoading = true;
        this.listLoadError = false;

        let lThis:any = this;
        lThis.$http.getDiscussTopicList(this.keyword, this.cityId, 1, this.cat, this.pageNo, this.pageSize, (errorInfo: ErrorInfo, data: DiscussTopicList) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.listLoadError = true;
            } else {
                data && data.list.forEach((item: DiscussTopicInfo) => {
                    // 去重 
                    let exist: boolean = false;
                    for (let n = 0; n < this.listData.length; n++) {
                        if (this.listData[n].id === item.id) {
                            exist = true;
                            break;
                        }
                    }

                    if (!exist) {
                        this.listData.push(item);
                    }
                });

                this.pageNo = this.pageNo + 1;

                if (data && this.pageNo > data.pagination.totalPage) {
                    this.listFinished = true;
                }
            }

            this.listLoading = false;
        });
    }
}
